import React from 'react';
import { bool } from 'prop-types';
import { LazyComponent, StatusToast } from '@fiverr-private/orca';
import { translate } from '@fiverr-private/i18n-react';
import LoadingPlaceholder from './LoadingPlaceholder';

const lazyImport = () => import(/* webpackChunkName: 'ContactSellerPopoverContent' */'./Content');

const ContactSellerPopoverContent = ({
    isOpen = false,
    ...componentProps
}) => {
    const onError = () => {
        StatusToast.raise({
            message: translate('send_message.validation.something_wrong'),
            theme: StatusToast.THEMES.ERROR
        });
    };

    return (
        <LazyComponent lazyImport={lazyImport}
            componentProps={componentProps}
            shouldImport={isOpen}
            placeholder={<LoadingPlaceholder/>}
            onError={onError}/>
    );
};

ContactSellerPopoverContent.propTypes = {
    isOpen: bool
};

export default ContactSellerPopoverContent;
